export default __webpack_public_path__ + "static/media/Mask of the Starless Night.a6614181.jpg";